'use strict';

var AppDispatcher = require('../AppDispatcher'),
    _ = require('underscore'),
    UserStore = require('./UserStore'),
    { createStore, mergeIntoBag, isInBag } = require('../utils/StoreUtils');

var socialFriends = {};

var NON_LETTERS_RE = /[\s\.,-\/#!$%\^&\*;:{}=\-_`~()'"“”]/g;

function getKeywords(friend) {
  var nameWords = (friend.name || '').split('@')[0].split(NON_LETTERS_RE),
      emailWords = (friend.email || '').split('@')[0].split(NON_LETTERS_RE);

  return _.compact(nameWords.concat(emailWords)).map(function (word) {
    return word.toLowerCase();
  });
}

var SocialFriendStore = createStore({
  contains(slug, fields) {
    return isInBag(socialFriends, slug, fields);
  },

  get(id) {
    return socialFriends[id];
  }
});

SocialFriendStore._objects = socialFriends;

SocialFriendStore.dispatchToken = AppDispatcher.register(function (payload) {
  AppDispatcher.waitFor([UserStore.dispatchToken]);

  var action = payload.action,
      response = action.response,
      entities = response && response.entities,
      receivedFriends = entities && entities.socialFriends;

  switch (action.type) {
  default:
    if (receivedFriends) {
      _.each(receivedFriends, function (friend) {
        friend.keywords = getKeywords(friend);
        return friend;
      });

      mergeIntoBag(socialFriends, receivedFriends);
      SocialFriendStore.emitChange();
    }
    break;
  }
});

module.exports = SocialFriendStore;


/** WEBPACK FOOTER **
 ** ./stores/SocialFriendStore.js
 **/